import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-4">
        {/* Vous pouvez remplacer ceci par une image personnalisée */}
        <div className="mb-8">
          <img
            src="https://illustrations.popsy.co/gray/crashed-error.svg"
            alt="404 Illustration"
            className="mx-auto w-64 h-64"
          />
        </div>
        
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-gray-700 mb-4">
          Page introuvable
        </h2>
        <p className="text-gray-500 mb-8 text-lg">
          Désolé, la page que vous recherchez semble avoir disparu...
        </p>
        
        <Link
          to="/"
          className="btn btn-primary"
        >
          Retourner à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
